import React from 'react'
import { useStaticQuery, graphql } from 'gatsby'
import styled from '@emotion/styled'
import HeadingBorder from 'src/components/atoms/HeadingBorder'
import ContentsWrapper from 'src/components/atoms/wrappers/ContentsWrapper'
import HeadTitle from 'src/components/atoms/HeadTitle'
import { BreakPoint, Styles } from 'src/components/shared/CssValues'
import { PartnerPointCard } from 'src/components/organisms/partner/PartnerPointCard'
import { PointCardLayout } from 'src/components/molecules/PointCardLayout'

const points = [
  {
    imageName: 'stable',
    title: 'ストック型、低い解約率で安定収益に',
  },
  {
    imageName: 'first_rank',
    title: '日本で最も選ばれている\nコミュニティプラットフォーム',
  },
  {
    imageName: 'all_industry',
    title: '業種業界問わず、あらゆる企業にご提案可能',
  },
  {
    imageName: 'support',
    title: '販売後のサポート体制も充実',
  },
  {
    imageName: 'differentiation',
    title: 'トレンド商材で他社との差別化',
  },
  {
    imageName: 'free',
    title: 'ノルマなし、登録料無料',
  }
]

export const PartnerAdvantage = () => {
    const data = useStaticQuery(graphql`
        query {
        stable: file(relativePath: { eq: "partner/advantage/stable.png" }) {
            childImageSharp {
            fluid(maxWidth: 600) {
                ...GatsbyImageSharpFluid
            }
            }
        }
        first_rank: file(relativePath: { eq: "partner/advantage/first-rank.png" }) {
            childImageSharp {
            fluid(maxWidth: 600) {
                ...GatsbyImageSharpFluid
            }
            }
        }
        all_industry: file(
            relativePath: { eq: "partner/advantage/all-industry.png" }
        ) {
            childImageSharp {
            fluid(maxWidth: 600) {
                ...GatsbyImageSharpFluid
            }
            }
        }
        support: file(relativePath: { eq: "partner/advantage/support.png" }) {
            childImageSharp {
            fluid(maxWidth: 600) {
                ...GatsbyImageSharpFluid
            }
            }
        }
        differentiation: file(relativePath: { eq: "partner/advantage/differentiation.png" }) {
            childImageSharp {
            fluid(maxWidth: 600) {
                ...GatsbyImageSharpFluid
            }
            }
        }
        free: file(relativePath: { eq: "partner/advantage/free.png" }) {
            childImageSharp {
            fluid(maxWidth: 600) {
                ...GatsbyImageSharpFluid
            }
            }
        }
        }
    `)

    return (
        <Container>
        <ContentsWrapper>
            <HeadingBorder heading="ADVANTAGE" />
            <HeadTitle>commmuneパートナーになるメリット</HeadTitle>
            <PointCardLayoutWrapper>
            <PointCardLayout>
                {points.map(point => {
                const { childImageSharp } = data[point.imageName]
                const imageFluid = childImageSharp && childImageSharp.fluid
                return (
                    <PartnerPointCard
                    key={point.imageName}
                    {...point}
                    imageFluid={imageFluid}
                    spVariant="left"
                    />
                )
                })}
            </PointCardLayout>
            </PointCardLayoutWrapper>
        </ContentsWrapper>
        </Container>
    )
    }

    const Container = styled.section`
    padding: ${Styles.spacing[11]} 0;
    @media screen and (min-width: ${BreakPoint.MOBILE}) {
        padding: ${Styles.spacing[14]} 0;
    }
    `

    const PointCardLayoutWrapper = styled.div`
    margin: ${Styles.spacing[11]} 0 0;
    @media screen and (min-width: ${BreakPoint.TABLET}) {
        margin: ${Styles.spacing[12]} 0 0;
    }
`
